import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {NotificationProps} from '../types';
import notificationsKeys from '../util/notifications-keys';

export interface EditNotificationProps extends Omit<NotificationProps, 'id'> {}

const useEditNotification = (id: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: NotificationProps) => {
    update(notificationsKeys.list(), data);
    setData(notificationsKeys.details(id), data);
  };

  return useApiMutation<EditNotificationProps>({
    url: `/notifications/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar notificação',
    successTitle: 'Editar notificação',
    successMessage: 'Notificação atualizada com sucesso',
    onSuccess,
  });
};

export default useEditNotification;
